import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpException, isNullOrUndefined, NetworkRequestTimeoutException } from '@uzurv/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import HttpStatusCode from '../../constants/http-status-code';

@Injectable()
export class HttpExceptionMappingInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse) {
          let message: string = err.statusText;
          if (!isNullOrUndefined(err.error)) {
            message = err.error.status;
          }

          if (err.status === HttpStatusCode.REQUEST_TIMEOUT || err.status === HttpStatusCode.GATEWAY_TIMEOUT) {
            if (isNullOrUndefined(message) || message.length === 0) {
              message = 'Network Request Timed Out';
            }
            return throwError(new NetworkRequestTimeoutException(HttpStatusCode.REQUEST_TIMEOUT, false, message));
          }

          if (isNullOrUndefined(message) || message.length === 0) {
            if (err.status === 401) {
              message = 'Unauthorized';
            } else if (err.status === 404) {
              message = 'URL Not Found';
            } else if (err.status === 403) {
              message = 'This action is forbidden';
            } else if (err.status === 504) {
              message = 'The server took too long to respond';
            } else {
              message = 'Unknown Error';
            }
          }

          return throwError(new HttpException(err.status, message));
        } else {
          return throwError(err);
        }
      })
    );
  }
}
